import { render, staticRenderFns } from "./CoordinateMatching.vue?vue&type=template&id=1efcee48&scoped=true"
import script from "./CoordinateMatching.vue?vue&type=script&lang=js"
export * from "./CoordinateMatching.vue?vue&type=script&lang=js"
import style0 from "./CoordinateMatching.vue?vue&type=style&index=0&id=1efcee48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efcee48",
  null
  
)

export default component.exports